module.exports = __webpack_public_path__ + "img/margarida.e7fb0450.jpg";